function containsUnsafeCharacters(value: string): boolean {
  for (const character of value) {
    const codePoint = character.codePointAt(0) ?? 0;
    if (codePoint <= 0x1f || codePoint === 0x7f || character === '\\') {
      return true;
    }
  }
  return false;
}

function browserOrigin(): string | undefined {
  return typeof window === 'undefined' ? undefined : window.location.origin;
}

/**
 * Resolve a browser navigation target only when it remains on the supplied
 * HTTP(S) origin. Callers receive a parsed URL so the same checked value is
 * used for both the rendered href and the navigation sink.
 */
export function buildSameOriginUrl(
  value: string | undefined,
  expectedOrigin = browserOrigin(),
): URL | undefined {
  if (!value || !expectedOrigin || value !== value.trim() || containsUnsafeCharacters(value)) {
    return undefined;
  }
  try {
    const base = new URL('/', expectedOrigin);
    if (!['http:', 'https:'].includes(base.protocol) || base.origin !== expectedOrigin) {
      return undefined;
    }
    const resolved = new URL(value, base);
    if (
      resolved.origin !== base.origin ||
      resolved.protocol !== base.protocol ||
      resolved.username ||
      resolved.password
    ) {
      return undefined;
    }
    return resolved;
  } catch {
    return undefined;
  }
}

export function sameOriginRoute(url: URL): string {
  return `${url.pathname}${url.search}${url.hash}`;
}
